var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClearIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 16,
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.70709 11.7071L12 9.41415L14.2929 11.7071L15.7071 10.2928L13.4142 7.99994L15.7071 5.70706L14.2929 4.29285L12 6.58573L9.70712 4.29285L8.29291 5.70706L10.5858 7.99994L8.29288 10.2928L9.70709 11.7071Z",
  fill: "#767676"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 0C6.19314 0 5.90327 0.140888 5.71368 0.382178L0.213682 7.38218C-0.0712272 7.74479 -0.0712272 8.25521 0.213682 8.61782L5.71368 15.6178C5.90327 15.8591 6.19314 16 6.5 16H17C18.6569 16 20 14.6569 20 13V3C20 1.34315 18.6569 0 17 0H6.5ZM2.27175 8L6.98604 2H17C17.5523 2 18 2.44772 18 3V13C18 13.5523 17.5523 14 17 14H6.98604L2.27175 8Z",
  fill: "#767676"
})));
export { SvgClearIcon as ReactComponent };
export default __webpack_public_path__ + "assets/32c7c21c.svg";